// extracted by mini-css-extract-plugin
export default {"cls1":"WinBackPing-cls1___17bba5ddd7585d72fdb","cls2":"WinBackPing-cls2___49828706c5e62a16c7b WinBackPing-cls1___17bba5ddd7585d72fdb"};